/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAdf = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m3 16 2.65-6.98H7.1L9.767 16h-1.67l-.461-1.43H5.064L4.604 16H3zm2.467-2.698h1.757l-.883-2.745-.874 2.745zM10.514 16V9.02h2.343c1.139 0 2 .295 2.582.884.583.589.874 1.46.874 2.611 0 1.14-.291 2.007-.874 2.602-.576.589-1.437.883-2.582.883h-2.343zm2.324-5.76h-.826v4.54h.826c.646 0 1.126-.182 1.44-.546.32-.372.48-.944.48-1.719 0-.774-.157-1.347-.47-1.718-.314-.371-.798-.557-1.45-.557zM17.377 16V9.02h4.454v1.268h-2.956v1.757h2.62v1.267h-2.62V16h-1.498z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAdf as Adf };
